/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Select charge percentage between one of two options: 80 or 100.
 *
 */
export var chargeUpto;
(function (chargeUpto) {
    chargeUpto["_80"] = "80";
    chargeUpto["_100"] = "100";
})(chargeUpto || (chargeUpto = {}));
